import { PayloadAction } from '@reduxjs/toolkit';
import { ToastNotificationState } from './toastNotificationSlice';
import { getEpochTimeInSecond } from './toastNotificationHelper';
import { v4 as uuidv4 } from 'uuid';

export const setNotificationDataReducer = (
  state: ToastNotificationState,
  action: PayloadAction<any>,
) => {
  const data = JSON.parse(JSON.stringify(state.data));
  const addedNewData = Boolean(action.payload);

  if (addedNewData) {
    const duplicate = data.latestData.find((item) =>
      Boolean(item.message === action.payload.message && item.title === action.payload.title),
    );
    if (!duplicate) {
      action.payload.id = uuidv4();
      action.payload.epochTimeInSec = getEpochTimeInSecond();
      data.latestData.push(action.payload);
    }
  } else {
    data.latestData.shift();
  }
  state.data = {
    addedNewData,
    latestData: data.latestData,
  };
};

export const removeNotificationByIndexReducer = (
  state: ToastNotificationState,
  action: PayloadAction<number>,
) => {
  const data = JSON.parse(JSON.stringify(state.data));
  const index = action.payload;
  if (index >= 0 && index < data.latestData.length) {
    data.latestData.splice(index, 1);
  }
  state.data = {
    addedNewData: false,
    latestData: data.latestData,
  };
};

export const removeNotificationByIdReducer = (
  state: ToastNotificationState,
  action: PayloadAction<string>,
) => {
  const data = JSON.parse(JSON.stringify(state.data));
  data.latestData = data.latestData.filter((item) => item.id !== action.payload);
  state.data = {
    addedNewData: false,
    latestData: data.latestData,
  };
};
